import { useCreateCredential } from '@givebacks/shop';
import { AxiosError } from 'axios';
import { CheckoutCardProvider } from 'core/Components';
import { getErrorMessage_v2 } from 'core/Utils';
import { useUpdateUserSubscriptionPaymentMethod } from 'store/Api';
import { ButtonMantine, Modal, Stack, notifications } from 'ui';

import {
  ModalTitleWithBackButton,
  useDonationSettingModalProvider,
} from '../DonationSettingsModalProvider';

const UpdatePaymentMethodFooter = ({
  subscriptionId,
  onSuccess,
}: {
  subscriptionId?: string;
  onSuccess: () => void;
}) => {
  const { mutate: updateSubscriptionPaymentMethod, isPending: isLoading } =
    useUpdateUserSubscriptionPaymentMethod();

  const { createCredential } = useCreateCredential({
    onCredentialChange: () => void 0,
  });

  const handleCreateCredential = async () => {
    try {
      const result = await createCredential();
      updateSubscriptionPaymentMethod(
        {
          subscription_uuid: subscriptionId ?? '',
          subscription: {
            payment_method: result.stripe_payment_method.uuid,
          },
        },
        {
          onSuccess: () => {
            notifications.show({
              message: 'Payment method updated',
              variant: 'success',
            });
            onSuccess();
          },
          onError: (e) => {
            const error = e as Error | AxiosError;
            notifications.show({
              message: getErrorMessage_v2(error),
              variant: 'error',
            });
          },
        }
      );
    } catch (e) {
      const error = e as Error | AxiosError;
      notifications.show({
        message: getErrorMessage_v2(error),
        variant: 'error',
      });
    }
  };
  return (
    <ButtonMantine onClick={handleCreateCredential} loading={isLoading}>
      Update Payment Method
    </ButtonMantine>
  );
};

const UpdatePaymentMethodContent = ({
  subscriptionId,
  onSuccess,
}: {
  subscriptionId?: string;
  onSuccess: () => void;
}) => {
  return (
    <Stack gap="lg">
      <CheckoutCardProvider onCredentialChange={() => void 0} />
      <UpdatePaymentMethodFooter subscriptionId={subscriptionId} onSuccess={onSuccess} />
    </Stack>
  );
};

const UpdatePaymentMethodModal = () => {
  const { opened, close } = useDonationSettingModalProvider({
    id: 'UpdatePayment',
  });

  const { meta, openBack } = useDonationSettingModalProvider({});

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Update Payment Method</ModalTitleWithBackButton>}
    >
      <UpdatePaymentMethodContent subscriptionId={meta.subscriptionId} onSuccess={openBack} />
    </Modal>
  );
};

export { UpdatePaymentMethodContent, UpdatePaymentMethodModal };
